/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: medication-family.component.ts
 * Generated By : Toji Mathew on 3/8/2023
 /************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Settings } from '../../../services/settings';
import { MedicationFamily } from '../../../models/medicationfamily';
import { MedicationService } from '../../../services/medication.service';
import { ValidationResult } from '../../../models/validation-result';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../../components/transaction-history/transaction-history';
import { DwUtils } from '../../../components/utils/dw-utils';
import { SearchMedicationsComponent } from '../../shared/search-medications/search-medications.component';
import { MedSearchStructure } from '../../../models/med-search-structure';
import { MedicationIngredientsComponent } from './tabs/medication-ingredients/medication-ingredients.component';
import { MedicationPropertiesComponent } from './tabs/medication-properties/medication-properties.component';
import { NotesComponent } from 'src/app/components/notes/notes.component';

@Component({
	selector: 'app-medication-family',
	templateUrl: './medication-family.component.html',
	styleUrls: ['./medication-family.component.css']
})


export class MedicationFamilyComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Medication Family';
	public pagination: string;

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: MedicationFamily[];
	public selectedRecord: MedicationFamily;
	public historyRecord: MedicationFamily;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<MedicationFamily>;
	public renderedData: Array<any>;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;
	public activeCellId: string | null = '';
	public busyCursor: boolean | null = false;
	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public selectedViewFilter: string | null = 'List';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['id', 'description', 'itemPrefix', 'schedule', 'invWarningThreshold', 'expirationGraceDays', 'activeStatus'];

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleModify: boolean | null = false;
	public visibleDelete: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;
	public selectedDrawerIndex: number | null = 0;
	public id: any | null = '';
	public description: any | null = '';
	public itemPrefix: string | null;
	public invWarningThreshold: number | null = 0;
	public expirationGraceDays: number | null = 0;
	public schedule: any;
	public valStatus: any;
	/***** Side drawer ****/
	public propContainerState: boolean | null = false;
	public visiblePropertiesTab: boolean | null = true;
	public visibleNotesTab: boolean | null = true;
	public displaySearchDlg: boolean = true;
	public hideNoRecs: boolean = true;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;
	@ViewChild('search', { static: true }) search: SearchMedicationsComponent;
	@ViewChild('ingredients', { static: false }) ingredients: MedicationIngredientsComponent;
	@ViewChild('properties', { static: true }) properties: MedicationPropertiesComponent;
	@ViewChild('notes', { static: false }) notes: NotesComponent;

	constructor(private medicationService: MedicationService, private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new MedicationFamily();
		this.records = new Array<MedicationFamily>();
		this.dataSource = new MatTableDataSource<MedicationFamily>();
	}

	ngOnInit() {
		this.visibleAdd = true;
		this.visibleModify = true;
		this.visibleDelete = true;
		this.busyCursor = false;
	}
	ngAfterContentInit() {
		// this.queryRecords();

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
	}

	/*** Query Records from the Service ***/
	public queryRecords(sm: MedSearchStructure) {

		this.busyCursor = true;
		this.medicationService.getAllMedicationFamilyFromSearch(sm).subscribe(
			(result) => {
				this.records = result;
				this.dataSource = new MatTableDataSource(this.records);
				this.setPagination(-1, this.dataSource.data.length);
				this.onChangeStatusFilterValue(this.selectedStatusFilter);
				this.busyCursor = false;
				this.hideNoRecs = (this.records.length > 0);
				this.unSelectRow();
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve data from the service');
				this.busyCursor = false;
			}
		);
	}
	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public onStatusChange() {

		this.medicationService.updateMedicationFamily(this.selectedRecord).subscribe(
			(data) => {
				// no user feedback, just apply the filter ...
				this.onChangeStatusFilterValue(this.selectedStatusFilter);
			});
	}
	public doTabChange(event): void {
		this.displayDetail(this.selectedRecord);
	}
	public doDrawerTabChange($event) {
		this.displayDrawerData();
	}
	public onChangeStatusFilterValue(event: any): void {
		this.selectedStatusFilter = event;
		const dataTemp: MedicationFamily[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);

	}
	@HostListener('matSortChange', ['\$event'])
	onSortChange(event: any) {

		if (event.direction === 'asc') {
			this.records.sort((a, b) =>
				Number.isInteger(a[event.active]) ? a[event.active] - b[event.active] : a[event.active].localeCompare(b[event.active])
			);
		}
		else {
			this.records.sort((a, b) =>
				Number.isInteger(b[event.active]) ? b[event.active] - a[event.active] : b[event.active].localeCompare(a[event.active])
			);
		}

		this.dataSource.data = this.records;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public openSearchDialog(): void {
		this.displaySearchDlg = true;
		this.search.showDialogFocus();
	}
	public globalSearchSelect(medSearchStruct: MedSearchStructure): void {

		this.queryRecords(medSearchStruct);
		this.displaySearchDlg = false;
	}
	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}
	public applyFilter(filterValue: string) {
		if (this.isEditing) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new MedicationFamily();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);

	}
	public displayDetail(record: MedicationFamily) {
		if (record === undefined) {
			return;
		}
		if (this.selectedTabIndex === 0) {
			this.id = record.id;
			this.description = record.description;
			this.itemPrefix = record.itemPrefix;
			this.invWarningThreshold = record.invWarningThreshold;
			this.expirationGraceDays = record.expirationGraceDays;
			this.valStatus = record.activeStatus;
			this.schedule = record.schedule;

		} else {
			this.history.onShowHandler('medication-family', 'id', record.id.toString());
		}
		this.displayDrawerData();

	}
	public displayDrawerData() {
		if (!this.propContainerState) {
			return;
		}
		if (this.selectedDrawerIndex === 0) {
			this.properties.onShowHandler(this.selectedRecord.id);

		} else if (this.selectedDrawerIndex === 1) {
			this.ingredients.onShowHandler(this.selectedRecord);

		} if (this.selectedDrawerIndex === 2) {
			this.notes.onShowHandler(this.selectedRecord.id);
		}
	}
	public clear() {
		this.id = '';
		this.description = '';
		this.valStatus = 'Active';
		this.schedule = '0';
		this.invWarningThreshold = 0;
		this.expirationGraceDays = 0;
	}
	public addModifyRecord(isAdd: boolean) {
		this.isAdd = isAdd;
		this.isEditing = true;
		this.selectedTabIndex = 0;

		if (this.isAdd) {
			this.unSelectRow();
			this.clear();
			this.expirationGraceDays = 30;
			this.invWarningThreshold = 20;
			this.id = 0;
		}
		else {
			// store the history record
			this.historyRecord = this.selectedRecord;
		}
		DwUtils.setFocus('item_prefix');
	}
	public checkUniqueItemPrefix() {

		if ((this.itemPrefix === undefined) || (this.itemPrefix === '')) {
			return;
		}
		this.medicationService.getMedicationFamilyByItemPrefix(this.itemPrefix).subscribe(
			(data) => {
				if (data !== null) {
					this.strErr = 'Error: this Item Prefix (Pres-Core) is in use - please choose a' +
						' unique code';
					DwUtils.highlightFocus('item_prefix');
				}
			},
			(error) => {
				console.log(error);
			});
	}
	public doItemPrefixHint(): void {

		this.medicationService.getNextItemPrefixNumber().subscribe(
			(data) => {
				this.itemPrefix = data;
				DwUtils.highlightFocus('description');

			});
	}
	public removeRecord() {
		const message = 'Remove Medication Family: "' + this.selectedRecord.description + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.medicationService.deleteMedicationFamily(this.selectedRecord.id).subscribe(
					(data) => {
						// remove the row from the table.

						this.records.splice(this.Idx, 1);
						this.dataSource.data = this.records;
						this.clear();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}
	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;
		if (this.propContainerState) {
			this.displayDrawerData();
		}
	}
	public tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) {
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}

		return true;
	}
	public setRecord(): void {
		this.selectedRecord = new MedicationFamily();
		this.selectedRecord.id = this.id;
		this.selectedRecord.description = String(this.description).toUpperCase();
		this.selectedRecord.itemPrefix = this.itemPrefix;
		this.selectedRecord.invWarningThreshold = this.invWarningThreshold;
		this.selectedRecord.expirationGraceDays = this.expirationGraceDays;
		this.selectedRecord.activeStatus = this.valStatus;
		this.selectedRecord.schedule = this.schedule;
	}
	public submitRecord() {

		this.setRecord();
		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		if (this.isAdd === true) {
			this.medicationService.createMedicationFamily(this.selectedRecord).subscribe(
				(data) => {
					this.selectedRecord.id = data.id;
					this.displayDetail(this.selectedRecord);
					this.isEditing = false;
					/*** add a transaction history record ***/
					this.txService.createTransactionHistory('medication-family', this.selectedRecord.id);
					this.updateSelectedRow();
				},
				(error) => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		}
		else {

			this.medicationService.updateMedicationFamily(this.selectedRecord).subscribe(
				(data) => {
					this.isEditing = false;
					this.updateSelectedRow();
				},
				(error) => {
					this.strErr = 'Error: The server could not update this record';
					this.selectedRecord = this.historyRecord;
					return;
				});

			/*** add a transaction history record ***/
			this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'medication-family', this.selectedRecord.id);
		}

	}
	/* Update the record in the table's data source - without refreshing it */
	public updateSelectedRow(): void {
		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.Idx = 0;
		}
		else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;
		}
		this.dataSource.sort = this.sort;
	}
	public onRowClicked(selected: any) {

		if (this.isEditing === true || Settings.getInstance().isEditing === true)
			return;

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.displayDetail(this.selectedRecord);
	}
}
